import React from 'react';
import * as Types from './types';
import * as CGReact from './cg/cgreact';

import * as Panel2 from './panel';
import {PanelComp2} from './PanelComp';

type PanelMaybeProps = Panel2.PanelConverterProps;

const PanelMaybe: React.FC<PanelMaybeProps> = props => {
  const {input} = props;
  const nodeValueQuery = CGReact.useNodeValue(props.input.path);

  return nodeValueQuery.loading || nodeValueQuery.result == null ? (
    <div>-</div>
  ) : (
    <PanelComp2
      input={input}
      inputType={input.path.type}
      loading={props.loading}
      panelSpec={props.child}
      configMode={false}
      config={props.config}
      context={props.context}
      updateConfig={props.updateConfig}
      updateContext={props.updateContext}
    />
  );
};

export const Spec: Panel2.PanelConvertSpec = {
  id: 'maybe',
  displayName: 'Maybe',
  Component: PanelMaybe,
  convert: (inputType: Types.Type) => {
    if (Types.isSimpleType(inputType)) {
      return null;
    }
    if (inputType.type !== 'union') {
      return null;
    }
    const membersWithoutNull = inputType.members.filter(m => m !== null);
    if (membersWithoutNull.length === inputType.members.length) {
      // No null! Maybe means T | null
      return null;
    }
    if (membersWithoutNull.length === 1) {
      return membersWithoutNull[0];
    }
    return {type: 'union', members: membersWithoutNull};
  },
  defaultFixedSize: childDims => childDims,
};
